module.exports = __webpack_public_path__ + "static/media/Menu_Active.db93deb8.png";